/* M+RC NOIR — Product page helpers.
   1) Size Guide panel scrolls within itself, sized live to the space left below
      it in the viewport (so the chart is usable inside the pinned column).
   2) Click the Size Guide PHOTO to open a full zoom window (lightbox): a dim
      backdrop with the whole chart, scrollable, closed by the X / backdrop / Esc.
      Works on desktop and mobile. */
(function () {
  if (window.__mrcPdp) return;
  window.__mrcPdp = true;

  var SEL = '.mn-tabs__panel[data-mn-panel="size"]';
  var listenersBound = false;

  /* ---- 1) keep the inline Size Guide panel readable in the pinned column ---- */
  function fit() {
    var panels = document.querySelectorAll(SEL);
    for (var i = 0; i < panels.length; i++) {
      var p = panels[i];
      if (window.innerWidth < 990 || !p.classList.contains('is-active')) {
        p.style.maxHeight = '';
        p.style.overflowY = '';
        continue;
      }
      var top = p.getBoundingClientRect().top;
      var h = window.innerHeight - top - 16;
      if (h < 160) h = 160;
      p.style.maxHeight = h + 'px';
      p.style.overflowY = 'auto';
    }
  }

  function ensureListeners() {
    if (listenersBound) return;
    listenersBound = true;
    window.addEventListener('scroll', fit, { passive: true });
    window.addEventListener('resize', fit);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-mn-tab="size"]')) {
        setTimeout(fit, 0);
        setTimeout(fit, 80);
      }
    });
  }

  /* ---- 2) Size Guide zoom lightbox ---- */
  var overlay = null;
  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'mn-zoom-overlay';
    overlay.innerHTML =
      '<div class="mn-zoom-panel">' +
      '<button type="button" class="mn-zoom-close" aria-label="Close">×</button>' +
      '<img class="mn-zoom-img" alt="Size guide">' +
      '</div>';
    document.body.appendChild(overlay);
    /* Click anywhere in the zoom (the chart itself, the backdrop, or the X) closes it. */
    overlay.addEventListener('click', function () { closeZoom(); });
    return overlay;
  }
  function openZoom(src, alt) {
    var o = buildOverlay();
    var img = o.querySelector('.mn-zoom-img');
    img.src = src;
    if (alt) img.alt = alt;
    void o.offsetWidth; /* force reflow so the fade-in animates on first open */
    o.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeZoom() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var img = e.target.closest(SEL + ' img');
    if (img) { e.preventDefault(); openZoom(img.currentSrc || img.src, img.alt); }
  });

  /* ---- 3) Tab toggle: clicking the tab that is already open closes its section.
     Runs in the capture phase so, when collapsing, we can stop the theme's own
     tab handler from immediately re-opening it. Clicking a different tab still
     opens it normally (theme handler runs). ---- */
  document.addEventListener('click', function (e) {
    var lab = e.target && e.target.closest ? e.target.closest('[data-mn-tab]') : null;
    if (!lab || !lab.classList.contains('is-active')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    lab.classList.remove('is-active');
    var k = lab.getAttribute('data-mn-tab');
    var panel = document.querySelector('.mn-tabs__panel[data-mn-panel="' + k + '"]');
    if (panel) panel.classList.remove('is-active');
  }, true);

  /* ---- 4) Chain the Size Guide inner scroller to the page at its top/bottom
     edge. Chrome "latches" a wheel gesture to the inner scroller, so at the
     boundary it just stops instead of scrolling the page. Here, once the panel
     can't scroll further in the wheel's direction, we forward the scroll to the
     window. Desktop only (the inner scroller only exists on desktop). ---- */
  document.addEventListener('wheel', function (e) {
    if (window.innerWidth < 990) return;
    var p = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!p) return;
    if (p.scrollHeight <= p.clientHeight + 1) return; /* nothing to scroll inside */
    var atTop = p.scrollTop <= 0;
    var atBottom = Math.ceil(p.scrollTop + p.clientHeight) >= p.scrollHeight;
    if ((e.deltaY > 0 && !atBottom) || (e.deltaY < 0 && !atTop)) return; /* panel still has room */
    e.preventDefault();
    window.scrollBy(0, e.deltaY);
  }, { passive: false });

  var tries = 0;
  function tick() { ensureListeners(); fit(); if (tries++ < 20) setTimeout(fit, 250); }
  function start() { tries = 0; tick(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();
